import type { Dispatch } from 'redux';
import { TOAST_FADE_IN_DURATION, TOAST_FADE_OUT_DURATION } from '../../../components/common/toasts-container.ts';
import { randomString } from '../../../utils/string/randomString.ts';
import { createAction } from '../../createAction.ts';
import { ToastActionType, ToastState } from '../enums.ts';
import type { Toast, ToastOptions } from '../types.ts';

/**
 * Dispatches a toast. Returns the dispatched object.
 * If store is undefined, it will not dispatch the action and simply return the action.
 * If store is defined, it will dispatch the action and not return it.
 */
export const addToast = createAction(
  (message: string, { color = '#27AE60', timeout = 5000, id = randomString(24) }: ToastOptions = {}) =>
    (dispatch: Dispatch<Toast & { type: string }>) => {
      requestAnimationFrame(() => {
        dispatch({
          type: ToastActionType.Update,
          id,
          state: ToastState.Static
        });
      });

      setTimeout(() => {
        dispatch({
          type: ToastActionType.Update,
          id,
          state: ToastState.FadeOut
        });
      }, TOAST_FADE_IN_DURATION + timeout);

      setTimeout(() => {
        dispatch({
          type: ToastActionType.Clear,
          id
        });
      }, timeout + TOAST_FADE_IN_DURATION + TOAST_FADE_OUT_DURATION);

      dispatch({
        type: ToastActionType.Add,
        id,
        message,
        color,
        state: ToastState.FadeIn
      });
    }
);